import { Button, Table } from "antd";
import React, { useEffect, useState } from "react";
import {
	useDispatch, useSelector
}from "react-redux"
import "antd/lib/table/style/index.css";
import {
	appealsCollectiveActions
}from "../CollectiveAppeal/store/actions"

import "../../../pagination.css";
import СollectiveAppealUserForm from "./collectiveAppealUserForm";
import ConvertDBAddressToString from "../../../helpers/convertDBAddressToString";
import Edit from "../../../../public/Edit.svg";
import Cross from "../../../../public/Cross.svg";

const CollectiveAppealUsers = (props) => {
  const columns = [
    {
      title: "№",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "ФИО",
      dataIndex: "FIO",
      render: (user) => (
        <p>
          {user
            ? `${user.ApplicantLastName} ${user.ApplicantFirstName}${
                user.applicantMiddleName != null
                  ? ` ${user.applicantMiddleName}`
                  : ""
              }`
            : ""}
        </p>
      ),
    },
    {
      title: "Электронная почта",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Адрес",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "",
      dataIndex: "change",
      key: "change",
      render: (id) => (
        <img
          src={Edit}
          className={"icon-edit"}
          onClick={() => changeUser(id)}
        />
      ),
    },
    {
      title: "",
      dataIndex: "deleteUser",
      key: "deleteUser",
      render: (id) => (
        <img
          src={Cross}
          className={"icon-delete"}
          onClick={() => deleteUser(id)}
        />
      ),
    },
  ];

  const dispatch = useDispatch()
  const {applicantsOrgList} = useSelector((state) => state.collectiveAppealReducer)
  const { i18n, isRu, userList, setUserList, isDisabled, appealId = null, resetRepetition } = props;
  const [userListTable, setUserListTable] = useState(null);
  const [visible, setVisible] = useState(false);
  const [changedUser, setChangedUser] = useState(null);
  const [usersIncrement, setUsersIncrement] = useState(0);

  useEffect(() => {
    if(appealId != null)
    dispatch(appealsCollectiveActions.GetOrgCollectiveAppealUserList({
      AppealId : appealId
      }))
  },[])

  useEffect(() => {
		if(applicantsOrgList?.length > 0)
		setUserList(applicantsOrgList?.map((user, number) => {
			return {
				id						        : number,
				ApplicantFirstName 		: user.applicantFirstName,
				ApplicantMiddleName		: user.applicantMiddleName,
				ApplicantLastName  		: user.applicantLastName,
				ApplicantEmail 	   		: user.applicantEmail,
				Address		       		: user.address?.reAddress,
				AdministrativeTerritory : user.address?.reAdministrativeTerritory,
				District		   		: user.address?.reAdministrativeTerritory?.reDistrict,
				House			   		: user.address?.house,
				Notice             		: user.address?.notice,
				Office             		: user.address?.office,
				ReCountry          		: user.address?.reCountry,
				Region             		: user.address?.reAdministrativeTerritory?.reRegion,
				postIndex         		: user.address?.postIndex,
				isOutsideRB		  		: user.address?.reAdministrativeTerritory ? false : true,
        LastId              : user.id,
        IsChanged             : false
      }
		}))
	}, [applicantsOrgList])

  useEffect(() => {
    if (userList) {
      let usersData = [];
      userList.forEach((val, index) => {
        let address = {
          reAddress: val.Address,
          reAdministrativeTerritory: val.AdministrativeTerritory,
          house: val.House,
          office: val.Office,
          notice: val.notice,
          isOutsideRB: val.isOutsideRB,
          postIndex: val.postIndex,
          reCountry: val.ReCountry,
        };
        address.reAdministrativeTerritory
          ? (address.reAdministrativeTerritory.reRegion = val.Region)
          : null;
        address.reAdministrativeTerritory
          ? (address.reAdministrativeTerritory.reDistrict = val.District)
          : null;
        usersData.push({
          index: index + 1,
          key: index,
          FIO: {
            ApplicantLastName: val.ApplicantLastName,
            ApplicantFirstName: val.ApplicantFirstName,
            ApplicantMiddleName: val.ApplicantMiddleName,
          },
          email: val.ApplicantEmail,
          address: ConvertDBAddressToString(address, isRu),
          change: val.id,
          deleteUser: val.id,
        });
      });
      setUsersIncrement(userList.length)
      setUserListTable(usersData);
    }
  }, [userList]);

  function handleCancel() {
    setVisible(false);
    setChangedUser(null);
  }

  function openModal() {
    setVisible(true);
  }

  function addUser(newUser) {
    newUser.id = usersIncrement;
    setUsersIncrement(usersIncrement + 1);
    if (userList) setUserList([...userList, newUser]);
    else setUserList([newUser]);
  }

  function deleteUser(id) {
    setUserList(
      userList.filter((val) => {
        return val.id !== id;
      })
    );
  }

  function changeUser(id) {
    const user = userList.find((val) => {
      return val.id === id;
    });
    setChangedUser(user);
    setVisible(true);
  }

  function updateUser(user, userId) {
    const users = [...userList]
    let oldUserIndex = users.findIndex(item => item.id == userId)
    users[oldUserIndex] = {id: userId, IsChanged: true, ...user}
    setUserList([...users])
  }

  return (
    <>
      <Button
        disabled = { isDisabled }
        ghost
        type="primary"
        onClick={openModal}
        style={{
          color: "#FCA806",
          borderColor: "#fdb11c",
          marginBottom: "24px",
          minWidth: "300px"
        }}
      >
        {i18n.CollectiveAppealUserAddButton[isRu]}
      </Button>
      {userListTable?.length > 0 ? (
        <Table columns={columns} dataSource={userListTable} />
      ) : null}
      <СollectiveAppealUserForm
        isDisabled = {isDisabled}
        addUser={addUser}
        changedValue={changedUser}
        handleCancel={handleCancel}
        i18n={i18n}
        isRu={isRu}
        setChangedUser={setChangedUser}
        resetRepetition={resetRepetition}
        updateUser={updateUser}
        visible={visible}
      />
    </>
  );
};

export default CollectiveAppealUsers;
